import { render, staticRenderFns } from "./ConfigWebsiteMerchandising.vue?vue&type=template&id=4e5459c1&scoped=true"
import script from "./ConfigWebsiteMerchandising.vue?vue&type=script&lang=js"
export * from "./ConfigWebsiteMerchandising.vue?vue&type=script&lang=js"
import style0 from "./ConfigWebsiteMerchandising.vue?vue&type=style&index=0&id=4e5459c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5459c1",
  null
  
)

export default component.exports